'use client'

import { QuestionCircle24 } from '@vinted/monochrome-icons'
import { Cell, Icon } from '@vinted/web-ui'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { clickEvent } from '@marketplace-web/messaging/tracking-data'
import {
  HELP_FAQ_ENTRIES_URL,
  TRANSACTION_FAQ_ENTRY_URL,
} from '@marketplace-web/messaging/navigation-feature'

import { AccessChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'

type Props = {
  transactionId?: number
}

const HelpAction = ({ transactionId }: Props) => {
  const translate = useTranslate()
  const { track } = useTracking()
  const { relativeUrl } = useBrowserNavigation()

  const trackHelp = () => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'help',
        screen: 'order_details',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const url = transactionId
    ? urlWithParams(TRANSACTION_FAQ_ENTRY_URL(transactionId), {
        access_channel: AccessChannel.ConversationTx,
        ref_url: relativeUrl,
        related_only: false,
      })
    : urlWithParams(HELP_FAQ_ENTRIES_URL, {
        access_channel: AccessChannel.ConversationNoTx,
        ref_url: relativeUrl,
      })

  return (
    <Cell
      title={translate('conversation.conversation_info.conversation_actions.help')}
      prefix={<Icon name={QuestionCircle24} color="primary-default" />}
      type="navigating"
      url={url}
      onClick={trackHelp}
    />
  )
}

export default HelpAction
